import { getCookie, setCookie } from "@/utils/cookies";
import ms from "ms";

const cookieName = "color-scheme";
const ttl = ms("1y");
const defaultColorScheme = "light";
export const getColorScheme = async () => {
  const colorScheme = await getCookie(cookieName);
  return colorScheme || defaultColorScheme;
};

export const setColorScheme = (colorScheme: string) =>
  setCookie(cookieName, colorScheme, { expires: ttl });
